// extracted by css-extract-rspack-plugin
export default {"viewed":"MarkAsViewedButton-module__viewed__k8dzo","iconOnly":"MarkAsViewedButton-module__iconOnly__kEP4e"};